'use client';

import React, { useEffect } from 'react';
import { updateUserProfile } from 'stores/userActions';
import useEditProfileStore from '@/components/store/editProfileModalSlice';
import { handleUpdateTheme } from '@/utils/theme';

const defaultTheme = {
  primaryColor: '#33CCCC',
  secondaryColor: '#ECA400',
};

const InitUserStore = (props) => {
  const { user, editProfile = null } = props;
  const setIsOpen = useEditProfileStore((state) => state.setOpen);

  useEffect(() => {
    if (user) {
      updateUserProfile(user);
      const theme = user?.activeCommunity?.theme || defaultTheme;
      if (theme) {
        handleUpdateTheme(theme);
      }
    }

    if (editProfile) {
      setIsOpen(true, user, editProfile);
    }
  }, []);

  return null;
};

export default InitUserStore;
